<h2 mat-dialog-title>'האם להפוך הזמנה לסטטוס "הסתיים ואושר"?'</h2>
<mat-dialog-actions>
  <button mat-button (click)="onYes()">כן</button>
  <button mat-button (click)="onNo()">לא</button>
</mat-dialog-actions>